// Sets shopping cart empty
export function newCart() {
  return {
    list: [],
    total: 0.0,
  }
}